const ITEMS = [
  "If you're looking for a get-rich quick play that doesn't involve doing the reps, this isn't it.",
  "If you want to \"think about it for a few months,\" that's fine. We'll be here. But the call right now is for people ready to move in 90 days.",
  "If you can't comfortably make a real investment in your skill right now, don't book the call. The call isn't where we figure out your finances. The call is where we figure out if you're a fit.",
  "If you've already tried three programs and you're hunting for the magic one that will work without you working, we're not it.",
];

export default function NotForYou() {
  return (
    <section className="access-section bg-room-2 border-y border-soft">
      <div className="access-container max-w-3xl">
        <span className="mono-label mono-label-gold">HONEST DISQUALIFICATION</span>
        <h2 className="h-section mt-5">This isn't for everyone. Save us both the call if it isn't for you.</h2>
        <ul className="mt-10 space-y-5">
          {ITEMS.map((t, i) => (
            <li key={i} className="flex gap-4 border-l-2 border-danger/60 pl-5 py-1">
              <span className="mono-label text-danger mt-1.5">{String(i + 1).padStart(2, "0")}</span>
              <p className="body-lg text-dim">{t}</p>
            </li>
          ))}
        </ul>
        <p className="mt-10 body-lg">
          If any of the above is you, save us both the time.
        </p>
        <p className="body-lg text-bone mt-2">
          If none of it is you, the call is below.
        </p>
      </div>
    </section>
  );
}
